import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { ellipsisMultiline } from '@/styles/helpers';

export const Box = styled.div<{ $isHidden?: boolean }>`
  background-color: ${({ theme }) => theme.palette.primary.background};
  width: 100%;
  padding: 10px 0;

  ${({ $isHidden }) =>
    $isHidden &&
    css`
      display: none;
    `}

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0;
  }
`;

export const InnerBox = styled.div`
  padding: 10px 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 10px 15px;
  }
`;

export const Title = styled(Typography.Header)`
  ${ellipsisMultiline(3)}
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Amount = styled(Typography.Text)`
  font-size: 12px;
  margin-left: 5px;
  color: ${({ theme }) => theme.palette.secondary.labels};
  vertical-align: middle;
`;
